export default function useFormatPrice(price: any) {
    const numericPrice = typeof price === 'number' ? price : parseFloat(price);

    if (isNaN(numericPrice)) {
        console.error('Invalid price value:', price);
        return 'Invalid price';
    }

    return numericPrice.toFixed(2).replace('.', ',');
}
